import { render, staticRenderFns } from "./submit-reset-button-groop.vue?vue&type=template&id=461e7bff&"
import script from "./submit-reset-button-groop.vue?vue&type=script&lang=ts&"
export * from "./submit-reset-button-groop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports